import { Component, inject } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { ModalService } from '../../../../services';

@Component({
  selector: 'lib-fw-table-row-wrapper',
  templateUrl: './table-row-wrapper.component.html',
  styleUrls: ['./table-row-wrapper.component.scss'],
})
export class FormlyTableRowWrapperComponent extends FieldWrapper {
  private readonly modalService = inject(ModalService);

  get labelIndentCssClass(): string {
    return this.props.labelIndent ? 'pl-5' : null;
  }

  openTooltip(triggerButton: HTMLElement) {
    this.modalService
      .open({
        title: this.props.label,
        message: this.props.helpText,
        hideClose: true,
        showButtons: true,
        hideSubmit: true,
        cancelLabel: 'Close',
        defaultFocus: 'content',
      })
      .then(
        () => triggerButton.focus(),
        () => triggerButton.focus(),
      );
  }

  close() {
    this.modalService.close();
  }
}
